export default __webpack_public_path__ + "static/media/customer3.3dd6cbef.svg";